import { useTheme } from '@mui/material/styles';

import { FormattedMessage } from "react-intl";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from '@mui/icons-material/Clear';
import Button from "@mui/material/Button";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { TextareaAutosize } from "@mui/material";

export default function WebhookExecutionErrorMessageDialog(props) {
  const {
    open,
    handleOpenOrClose,
    errorMessage = ""
  } = props;

  const theme = useTheme();

  if (!open || !errorMessage) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={handleOpenOrClose}
      aria-labelledby="newuser-dialog-title"
      scroll="paper"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle id="newuser-dialog-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6"><FormattedMessage id="webhook.execution.report.informations.error.message" /></Typography>
          <IconButton aria-label="close" size="small" onClick={handleOpenOrClose}>
            <ClearIcon fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent
        dividers
        sx={{
          width: '100%',
          minHeight: '200px',
          m: 2
        }}
      >
        <Grid container spacing={2}>
          <TextareaAutosize
            minRows={4}
            value={errorMessage}
            readOnly
            style={{ width: '100%', padding: 8, fontSize: 14, borderRadius: 4 }}
          />
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            color='primary'
            type="button"
            onClick={handleOpenOrClose}
            sx={{ minWidth: 120 }}
          >
            <FormattedMessage id="close" />
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
